import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adapter from "./adapter";
import service from "./service";

const initialState = {
  _payload: {},
  status: "idle",
  error: "",

  // Program Detail Page Data
  idToFetch: null,
  data: {
    title: {
      en: '',
      id: ''
    }
  },

  pdf_field: {
    cover_title: true,
    cover_main_image: true,
    cover_logo: true,
    cover_name: true,
    cover_approach: true,
    cover_issue: true,
    cover_datetime: true,
    cover_officer: true,
    cover_partner: true,
    detail_title: true,
    detail_image: true,
    detail_description: true,
    detail_milestone: true,
    detail_location: true,
    detail_journey: true,
    statistic_beneficiaries_total: true,
    statistic_beneficiaries_gender: true,
    statistic_beneficiaries_gender_difable: true,
    statistic_impact_survey: true,
    statistic_impact_retention: true,
    statistic_impact_satisfaction: true,
    statistic_impact_nps: true,
    statistic_impact_cac: true,
    other_testimonial: true,
    other_story_of_change: true,
    other_gallery: true,
  }
};

export const fetchProgram = createAsyncThunk(
  "program/fetchProgram",
  async (id) => {
    const data = await service.getData(id);
    return data;
  }
);

export const programSlice = createSlice({
  name: "program",
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    setIdToFetch(state, action){
      state.idToFetch = action.payload
    },
    setPdfField(state, action){
      state.pdf_field = action.payload
    }
  },
  extraReducers: {
    [fetchProgram.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchProgram.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state._payload = action.payload
      state.data = adapter.responseBodyToRender(action.payload)
    },
    [fetchProgram.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
  },
});

export const { setStatus, setIdToFetch, setPdfField } = programSlice.actions

export default programSlice.reducer;
